var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRing4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 236,
    height: 245.315,
    viewBox: "0 0 236 245.315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    opacity: 0.03,
    d: "M57.2646 17.4143C94.6144 -5.13797 141.386 -5.13797 178.735 17.4143C213.967 38.6877 235.5 76.8442 235.5 118V127.315C235.5 168.471 213.967 206.627 178.735 227.901C141.386 250.453 94.6144 250.453 57.2646 227.901C22.0331 206.627 0.5 168.471 0.5 127.315V118C0.5 76.8442 22.0331 38.6877 57.2646 17.4143Z",
    stroke: "#03A388"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing4);
export default __webpack_public_path__ + "static/media/ring4.d770d6c2e0d77cd06eb1961bb4bcc9df.svg";
export { ForwardRef as ReactComponent };